import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-database-03',
  standalone: true,
  templateUrl: './rt-icon-database-03.component.html',
  styleUrls: ['./rt-icon-database-03.component.scss']
})
export class RtIconDatabase03Component {
  @Input() width: number | string = 15;
  @Input() height: number | string = 17;
}
